<template>
  <fieldset class="list-group">
    <input type="hidden" value="" :name="inputName" v-if="newItems.length === 0">
    <input :type="itemType" class="list-group-item form-control" :name="inputName" v-for="(item, index) in newItems" v-model="item.value" :key="index" @blur="handleBlur(item)" @keypress="handlePress" :pattern="itemPattern">
    <input :type="itemType" class="list-group-item form-control" @input="handleNew" :placeholder="placeholder" v-model="newItem" ref="newItem">
  </fieldset>
</template>

<script>
export default {
  name: "StringArray",
  props: {
    objectName: {
      type: String,
      required: true
    },
    attributeName: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      default: 'text'
    },
    itemPattern: String,
    items: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    inputName(){
      return `${this.objectName}[${this.attributeName}][]`
    }
  },
  data() {
    return {
      newItems: this.items.map(item => ({value: item})),
      newItem: ''
    }
  },
  methods: {
    handleNew(){
      if(this.newItem.trim().length > 0){
        this.newItems.push({value: this.newItem.trim()})
        this.newItem = ""
        this.$nextTick(() => {
          this.$refs.newItem.previousElementSibling.focus()
        })
      }
    },
    handlePress(event){
      if(event.keyCode === 13) {
        event.preventDefault()
        if(event.target.reportValidity())
          event.target.nextElementSibling.focus()
      }
    },
    handleBlur(item) {
      if(item.value.trim() === '') {
        this.newItems.splice(this.newItems.indexOf(item), 1)
      }
    }
  }
}
</script>